import * as React from "react";
import { Box } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DatePickerComponentStyle from "./DatePickerComponentStyle";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { DatePickerProps as DatePickerCompProps, } from "@mui/x-date-pickers/DatePicker";
interface DatePickerProps extends DatePickerCompProps<any> {
  labelText: string;
  value?: string;
}

const DatePickerComponent: React.FC<DatePickerProps> = (props) => {

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-gb"}>
      <Box {...DatePickerComponentStyle.mainBox}>
        <label style={DatePickerComponentStyle.dateTitle}>
          {props.labelText}
        </label>
        <DesktopDatePicker
          slots={{ openPickerIcon: CalendarTodayOutlinedIcon }}
          sx={DatePickerComponentStyle.datePickerSx}
          format={"DD/MM/YYYY"}
          {...props}
          slotProps={{
            ...props.slotProps,
            textField: {
              ...props.slotProps?.textField, placeholder: "",
            },
            field: {
              readOnly: true, ...props.slotProps?.field,
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
